export const phoneRegExp =
  /^0[7-9][0-9]{9}$/;
